<div class="bg-gradient" *ngIf="hasGradient"></div>